export default "__VITE_ASSET__C5VPj0vt__"